<template>
	<CommentsForm :post_id="id" />

	<ClientOnly v-if="comments && comments.length > 0">
		<CommentList :comments="comments" />
	</ClientOnly>
</template>

<script setup>
defineProps({
	comments: {
		type: Array,
		required: true
	},
	id: {
		type: String,
		required: true
	}
});
</script>
